import React from 'react';

interface IndicatorMeasurementSelectionProps {
  text: string;
  selectedValue?: string;
  className: string;
  onClick: (value: string) => unknown;
}

const IndicatorMeasurementSelection: React.FC<IndicatorMeasurementSelectionProps> = ({
  text,
  selectedValue,
  className,
  onClick,
}) => {
  const handleClick = () => {
    onClick(text);
  };
  return (
    <button
      onClick={handleClick}
      className={`${className}${selectedValue === text ? ' selected' : ''}`}
    >
      {text}
    </button>
  );
};

export default IndicatorMeasurementSelection;
